import { useEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import Emitter from "../../helpers/emitters";
import { useDispatch } from "react-redux";
import { toggleFinishLoader360 } from "../../modules/store/slices/ui/ui";

export const useLoader = () => {
	const dispatch = useDispatch();
	const [animation, setAnimation] = useState(false);
	const loader = useRef(null);
	const ctx = useRef(null);
	const tl = useRef(null);

	const animationMethod = () => {
		tl.current
			.to("#gradiantBackground", {
				opacity: 0,
				duration: 2,
			})
			.to(
				loader.current,
				{
					opacity: 0,
					display: "none",
					onComplete: () => {
						dispatch(toggleFinishLoader360(true));
					},
				},
				2
			)
			.reverse();
	};

	useEffect(() => {
		ctx.current = gsap.context(() => {
			tl.current = gsap.timeline();
			animationMethod();
		});
		// return () => ctx.current.revert();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (animation) {
			tl.current.play();
		} else {
			// loader.current.classList.remove("hidden");
			tl.current.reverse();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [animation]);

	const toogleAnimation = () => {
		setAnimation(!animation);
	};

	useEffect(() => {
		Emitter.on("onLoadObject", (data) => {
			setAnimation(true);
		});
		Emitter.on("onProcessObject", (data) => {
			setAnimation(false);
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return {
		loader,
		toogleAnimation,
	};
};
